import { Combobox } from '@cko/primitives';
import styled from 'styled-components';
export const SearchableSelect = styled(Combobox) `
  min-width: 320px;
  > label {
    display: ${({ shouldLabelDisplay }) => (shouldLabelDisplay ? 'inline' : 'none')};
  }
`;
